import { supabase } from '../supabaseClient';

/**
 * Given an array of recipe objects and a language code,
 * fetches Hungarian translations and merges translated titles
 * back into the recipe objects. Returns a new array.
 */
export async function mergeRecipeTitles(recipes, language) {
  if (language !== 'hu' || !recipes || recipes.length === 0) return recipes;

  const ids = recipes.map((r) => r.id);
  const { data: translations } = await supabase
    .from('recipe_translations')
    .select('recipe_id, title')
    .in('recipe_id', ids)
    .eq('language_code', 'hu');

  if (!translations || translations.length === 0) return recipes;

  const map = {};
  translations.forEach((t) => { map[t.recipe_id] = t.title; });

  return recipes.map((r) => ({
    ...r,
    title: map[r.id] || r.title,
  }));
}
